import { render, staticRenderFns } from "./PartnerOfTheWeekEditor.vue?vue&type=template&id=77b2c844&scoped=true"
import script from "./PartnerOfTheWeekEditor.vue?vue&type=script&lang=js"
export * from "./PartnerOfTheWeekEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2c844",
  null
  
)

export default component.exports